import { render, staticRenderFns } from "./DraftMessage.vue?vue&type=template&id=cef5189a&scoped=true"
import script from "./DraftMessage.vue?vue&type=script&lang=js"
export * from "./DraftMessage.vue?vue&type=script&lang=js"
import style0 from "./DraftMessage.vue?vue&type=style&index=0&id=cef5189a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef5189a",
  null
  
)

export default component.exports